// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2wMho","header":"ReportDetails_header__2B2v9","title":"ReportDetails_title__3uK8V","left":"ReportDetails_left__3_eSs"};